import Preloader from './preloader.js';
export default Preloader;
